export const colors = {
  yellow: '#ff0',
};
